import emojiPickerI18n from '@web-lite/emoji-mart-data/i18n/fa.json'
import { LIMITS } from '@weblite/permission'
import { toLocale } from '$helper/functions/text'
import {
  getMessageToken,
  getTextToken,
  getUserToken,
} from '$comp/_app/components/chat/components/body/components/messageList/components/event/react-hook.helper'
import { boldSome } from '$comp/modals/confirmation-dialog/confirmation-dialog.helper'
import { dateTimeFormatter } from '$helper/functions/time'
import { LanguageType } from '../type'
import { FRONT_HOST, TWA_DOWNLOAD_SRC } from '$setup/local-language/constants'

const APP_NAME = 'پنل کاربری بنیاد شفیعی'
export const translationArabic: LanguageType = {
  serverError: 'تعذر الإتصال بالخادم',
  common: {
    add: 'إضافة',
    signup: 'ثبت نام',
    optional: 'اختیاری',
    pass: 'رد شدن',
    new: 'جدید', // TODO
    uploading: 'جاري التحميل...',
    you: 'أنت',
    from: 'من',
    ok: 'موافق',
    cancel: 'الغاء',
    notifications: 'إشعارات',
    loading: 'جارٍ التحميل...',
    search: 'بحث...',
    termsAndConditions: 'الشروط والأحكام',
    register: 'تسجيل',
    refuse: 'رفض',
    admin: 'المدير',
    owner: 'المالك',
    close: 'بستن', // TODO:
    etc: 'غیره', // TODO:
    online: 'عبر الانترنت',
    group: 'مجموعة',
    channel: 'قناة',
    settings: 'الإعدادات',
    verified: 'موثّقة',
    skip: 'تخطي',
    subscriber: 'مشترك',
    member: 'عضو',
    edit: 'تعديل',
    confirm: 'تأكيد',
    remove: 'إزالة',
    retry: 'حاول مرة أخرى',
    save: 'ذخیره', //  TODO:
    back: 'بازگشت',
    unlimited: 'غير محدود',
    revert: 'الرجوع',

    thousand: 'ألف',
    million: 'مليون',
    billion: 'مليار',

    second: 'ثانیه',
    minute: 'دقیقه',
    hour: 'ساعت',

    B: 'بايت',
    KB: 'کیلوبایت',
    MB: 'ميگابايت',
    GB: 'جيجابايت',

    male: 'ذكر',
    female: 'أنثى',

    today: 'اليوم',
    yesterday: 'في الأمس',
    soon: 'قریبا!',
    and: ' و ',
    resume: 'ادامه', // TODO
    understand: 'متوجه شدم',
    live: 'زنده', // TODO

    privateChannel: 'کانال خصوصی', // TODO

    dateFormats: {
      timeDay: (day, time) => `ساعت ${time} روز ${day}`,
      now: 'همین الان', //  TODO:
      nYearsAgo: (n: number) => `${n} سال قبل`,
      nMonthsAgo: (n: number) => `${n} ماه قبل`,
      nDaysAgo: n => `${n} روز قبل`,
      nHoursAgo: (n: number) => `${n} ساعت قبل`,
      nMinutesAgo: (n: number) => `${n} دقیقه قبل`,
      nYears: n => `${toLocale(n)} سال`,
      nMonths: n => `${toLocale(n)} ماه`,
      nWeeks: n => `${toLocale(n)} هفته`,
      nDays: n => `${toLocale(n)} روز`,
      nHours: n => `${toLocale(n)} ساعت`,
      nMinutes: n => `${toLocale(n)} دقیقه`,
      nSeconds: n => `${toLocale(n)} ثانیه`,
    },
    deactive: 'غیر فعال کردن', // TODO
    reload: 'بارگذاری مجدد', // TODO
  },
  navigationBar: {
    chat: 'محادثة',
    profile: 'حساب',
    generalIssue: 'تصحيح الأخطاء',
    workbench: 'مكتب',
    vitrine: 'عرض',
    workInProgress: 'این صفحه در حال توسعه است و به زودی از آن رونمایی می‌شود!',
  },
  JoinHallRequests: {
    requestsBarTitle: (count: number, type) =>
      `${toLocale(count, false)} درخواست برای عضویت در ${
        type === 'CHANNEL' ? 'کانال' : 'گروه'
      }`,
    list: {
      title: 'درخواست عضویت',
      emptyText: type =>
        `درخواستی برای عضویت در ${
          type === 'CHANNEL' ? 'کانال' : 'گروه'
        } وجود ندارد`,
      requestedToJoinAt: 'درخواست داده شده در',
      errorText: 'دریافت لیست درخواست‌ها با مشکل مواجه شد',
    },
  },

  joinClassField: {
    title: 'لینک عضویت در کلاس',
    placeholder: 'لینک خود را وارد کنید',
    submitText: 'عضویت',
    invalidLinkError: (remainingSeconds: number) =>
      `لینک نامعتبر است. ${toLocale(
        remainingSeconds,
      )} ثانیه دیگر دوباره امتحان کنید.`,
  },

  symbols: {
    openingDoubleQuotation: '»',
    closingDoubleQuotation: '«',
  },
  connectionStatus: {
    connecting: 'جارٍ الإتصال...',
    updating: 'جار المزامنة...',
    waitingForNetwork: 'در انتظار شبکه...', // TODO
    willReconnect: (delay: number) => `اتصال مجدد در ${delay} ثانیه`,
  },
  user: {
    name: 'الاسم',
    lastName: 'اللقب',
    // fatherName: 'اسم الأب ',
    educationPlace: 'مكان التعليم',
    phone: 'رقم الهاتف ',
    username: 'اسم المستخدم',
    bio: 'السيرة الشخصية',
    id: 'شناسه',
    enterName: 'أدخل الاسم ',
    enterLastName: 'أدخل اللقب ',
    // enterFatherName: 'أدخل اسم الأب ',
    // grade: 'التحصيل الدراسي',
    // birthdate: 'تأريخ الميلاد',
    status: {
      online: 'متصل',
      // add
      recently: 'آخرین بازدید به تازگی',
      withinAWeek: 'آخرین بازدید در هفته‌ی اخیر',
      withinAMonth: 'آخرین بازدید در یک ماه اخیر',
      aLongTimeAgo: 'آخرین بازدید خیلی وقت پیش',
      lastSeenAt: 'آخر ظهور في ',
      lastSeenYesterday: 'آخر ظهور امس في ',
    },
  },
  menu: {
    roomProfile: {
      viewProfile: 'مشاهده عکس پروفایل',
      viewStory: 'ورود به اطلاع رسانی', // TODO
    },
    profileImage: {
      newImage: 'تحميل صورة جديدة',
      replaceImage: 'تحميل صورة جديدة', // TODO
      deleteCurrent: 'حذف الصورة الحالية',
    },
    blockedUsers: {
      unblocking: 'رفع الحظر',
    },
    exceptionUser: {
      removeFromList: 'إزالة من القائمة',
    },
    phone: {
      call: 'إتصال',
      callThroughNetwork: 'تماس از طریق شبکه',
      copy: 'رونوشت',
      sendMessage: 'ارسال پیام',
      callThroughApp: 'تماس جریان',
      callThroughPhone: 'تماس از طریق تلفن همراه',
    },
    link: {
      open: 'فتح',
    },
    hall: {
      leaveGroup: 'ترك المجموعة',
      leaveChannel: 'ترك القناة',
      adminLeaveGroup: 'ترك وحذف المجموعة',
      removeFromGroup: 'حذف من المجموعة',
      removeFromChannel: 'حذف من القناة',
      editAdminRights: 'تعديل صلاحيات المدير',
      editRights: 'تعديل الصلاحيات',
      promote: 'ترقية الى مدير',
      dismissAdmin: 'عزل المدير',
    },

    common: {
      removeChat: 'حذف المحادثة',
      clearHistory: 'مسح السجل',
      markAsRead: 'وضع علامة ك مقروءة',
      markAsUnread: 'وضع علامة كغير مقروءة',
      copy: 'نسخ',
      select: 'اختيار',
      share: 'شارك',
      report: 'الإبلاغ عن محتوى غير لائق',
      remove: 'حذف',
    },
    call: {
      getAttendanceReport: 'لیست شرکت‌کنندگان',
    },
    admin: { editRights: 'تعديل', dismissAdmin: 'غض النظر' },
    removedUser: {
      addToChannel: 'إضافة الى القناة',
      addToGroup: 'إضافة الى المجموعة',
      delete: 'حذف من القائمة ',
    },
    inviteLink: {
      edit: 'تعديل الرابط ',
      revoke: 'تعطيل الرابط',
      remove: 'حذف الرابط',
    },
  },

  appBar: {
    search: 'بحث...',
  },

  story: {
    official: 'رسمی',
    nStories: n => `${n} اطلاع رسانی`, //   TODO:
    stories: 'اطلاع رسانی‌ها',
    addStory: 'افزودن اطلاع رسانی',
    yourStory: 'اطلاع رسانی شما',
    createStoryModal: {
      chooseOneOfBelowOptions: 'یکی از گزینه‌های زیر را انتخاب کنید',
      storyTypes: {
        image: 'عکس',
        video: 'فیلم',
      },
      submit: 'تایید و ارسال', // TODO
    },
    viewStoryModal: {
      addStory: 'افزودن اطلاع رسانی',
      deleteStory: 'حذف اطلاع رسانی', // TODO
    },
    deleteStoryModal: {
      title: 'حدف اطلاع رسانی',
      description: 'آیا از حذف این اطلاع رسانی اطمینان دارید؟', // TODO
    },
    noViewedYet: 'هنوز بازدیدی ثبت نشده است', // TODO
    sending: 'در حال ارسال',
  },

  syncIOSAccounts: {
    onboarding: {
      title:
        'برای دسترسی به مخاطبین جریان در iOS، باید از این طریق مخاطبین خود را انتخاب کنید.',
    },
    fabButtonLabel: 'بروزرسانی مخاطبین',
    nContactsDoesntHaveAppAccount: n =>
      `${n} مخاطب انتخاب شده در ${APP_NAME} حساب کاربری ندارند`,
    selectedContactDoesntHaveAppAccount: `مخاطب انتخاب شده در ${APP_NAME} حساب کاربری ندارد`,
    xAddedToContacts: name => `«${name}» به مخاطبین اضافه شد`,
    xAndNPersonsAddedToContacts: (name, n) =>
      `«${name}» و ${n} نفر دیگر به مخاطبین اضافه شدند`,
    howToEnableSyncDialog: {
      title: `برای دسترسی به مخاطبین ${APP_NAME} در iOS، ابتدا باید مراحل زیر را انجام دهید:`,
      steps: {
        first: 'وارد Settings گوشی خود شوید.',
        second: 'از بین برنامه‌ها Safari را انتخاب کنید.',
        third: 'در انتهای صفحه Advanced را انتخاب کنید.',
        fourth: 'گزینه Feature Flags را انتخاب کنید.',
        fifth: 'گزینه Contact Picker API را فعال کنید.',
        sixth: `برنامه ${APP_NAME} را کامل بسته و مجدد باز کنید.`,
      },
      confirm: 'متوجه شدم',
    },
  },

  profile: {
    hall: {
      deletedChannel: 'کانال حذف شده', // TODO:
      deletedGroup: 'گروه حذف شده', // TODO:
      inviteLink: 'رابط الدعوة ',
      description: 'الوصف',
      subscriber: 'الإشتراك',
      member: 'عضو',
      channelName: 'عنوان القناة',
      groupName: 'عنوان المجموعة ',
      enterChannelName: 'أدخل عنوان القناة',
      enterGroupName: 'أدخل عنوان المجموعة',
      enterChannelDescription: 'أدخل وصف القناة',
      enterGroupDescription: 'أدخل وصف المجموعة',
      noDescription: 'لا يوجد وصف',
      channelVitrine: 'ویترین کانال', // add

      options: {
        type: {
          groupType: 'نوع المجموعة',
          channelType: 'نوع القناة',
          private: 'خاصة',
          public: 'عامة',
        },
        historyForNewMembers: {
          title: 'سجل المحفوظات للأعضاء الجدد',
          visible: 'مرئي',
          hidden: 'مخفي',
        },
      },
      actions: {
        inviteViaLink: 'دعوة عبر الرابط ',
        setting: 'الإعدادات ',
        addMember: 'إضافة عضو',
        joinChannel: 'الإنضمام الى القناة',
        joinGroup: 'الإنضمام الى المجموعة',
        subscribers: 'المشتركون',
        members: 'أعضاء المجموعة ',
        admins: 'المدراء',
        addSubscriber: 'إضافة مشترك',
        membersPermissions: 'صلاحيات الأعضاء',
        inviteLinks: 'روابط الدعوة',
        removedUsers: 'المستخدمون المحذوفون',
        joinRequests: 'درخواست‌های عضویت', // TODO:
      },
      criticalActions: {
        deleteChannel: 'حذف القناة',
        deleteGroup: 'ترك وحذف المجموعة ',
      },
      removeUsers: {
        title: 'إزالة المستخدم ',
        removedBy: 'تمت الإزالة بواسطة',
      },
      joinedViaLink: {
        title: 'الأشخاص المنضمون عبر الرابط',
      },
    },
    user: {
      sendMessage: 'أرسل رسالة',
      block: 'حظر المستخدم',
      unblock: 'إلغاء حظر المستخدم',
      deleteContact: 'حذف جهة الإتصال',
      addToContacts: 'إضافة الى جهات الإتصال',
      deleteConversation: 'مسح المحادثة',
      clearHistory: 'مسح السجل ',
    },
    wapp: {
      sendMessage: 'عرض المحادثة',
      tool: 'أداة',
    },
    common: {
      sharedMedia: 'الوسائط المشتركة',
    },
    notification: {
      active: 'نشط',
      passive: 'غير نشط',
    },
  },
  multiTab: {
    refresh: 'تفعيل الصفحة',
    error: 'تم تعطيل هذه الصفحة',
    description:
      'لقد فتحت صفحة أخرى من التطبيق.' +
      'لذلك ، لتجنب المشاكل المحتملة ، قمنا بتعطيل هذه الصفحة',
  },
  myAccount: {
    plans: 'نسخه ویژه',
    usageDashboard: 'وضعیت مصرف اشتراک',
    account: 'حساب کاربری', // todo
    version: version => `نسخه ${version}`,
    contact: 'جهات الاتصال',
    contactUs: 'ارتباط با ما', // TODO
    balance: 'الرصيد ',
    credit: 'الإئتمان:',
    savedMessage: 'الرسائل المحفوظة',
    savedMessageDesc: 'مكان لتخزين رسائلك',
    privacyRules: 'قواعد الخصوصية',
    inviteFriends: 'دعوت از دوستان', // add
    support: 'الدعم',
    logout: 'تسجيل الخروج',
    addUserName: 'إختيار اسم المستخدم',
    addBio: 'عرف نفسك بإيجاز',
    blockedUsers: {
      block: 'حظر ', // TODO: Merge block titles
    },
    base: 'مقطع تحصیلی', // TODO
    faq: 'سوالات متداول',
    q1: {
      title: 'پلتفرم پنل کاربری بنیاد شفیعی چیست؟',
      description:
        'پنل کاربری بنیاد شفیعی پلتفرمی تخصصی برای برگزاری دوره‌های آنلاین است. این پلتفرم که بر پایه پیام‌رسان است، تمامی خدمات و ابزارهای لازم برای برگزاری یک دوره آنلاین را با بالاترین کیفیت و به صورت یکپارچه با داخل پیام‌رسان در اختیار مجموعه یا معلم قرار می‌دهد. ابزارهایی همچون کلاس آنلاین، آزمون تستی و تشریحی، نظرسنجی، تک‌تست و … از جمله این ابزارها هستند.',
    },
    q2: {
      title: 'چگونه پنل کاربری بنیاد شفیعی را روی موبایل و تبلت نصب کنم؟',
      description:
        'در حال حاضر تنها اپلیکیشن اندروید وجود دارد که آخرین نسخه آن را از بازار یا مایکت می‌توانید دریافت نمایید.\n' +
        '\n' +
        'برای سیستم‌عامل‌های دیگر مثل iOS، ویندوز، macOS و لینوکس می‌توانید از نسخه PWA که در آدرس https://weblite.me قرار دارد، استفاده نمایید.',
    },
    q3: {
      title: 'چگونه پنل کاربری بنیاد شفیعی را روی کامپیوتر شخصی داشته باشم؟',
      description:
        'برای دسترسی به پنل کاربری بنیاد شفیعی روی کامپیوتر شخصی و لپ تاپ می‌توانید از نسخه وب پنل کاربری بنیاد شفیعی که در آدرس  https://weblite.me وجود دارد استفاده نمایید.',
    },
    q4: {
      title: 'چگونه گروه یا کانال ایجاد کنم؟',
      description:
        'در صفحه گفت‌گو بر روی آیکون مداد کلیک نمایید و از لیست موجود گزینه ایجاد گروه یا ایجاد کانال را انتخاب نمایید. سپس در صفحه بعدی می‌بایست مشخصات گروه یا کانال که شامل نام، نوع، شناسه و توضیحات است را وارد کنید. در مرحله بعد مخاطبینی که تمایل دارید در گروه یا کانال شما عضو شوند را از لیست مخاطبان انتخاب نموده و با تایید نهایی گروه یا کانال مدنظر شما ایجاد می‌گردد.',
    },
    q5: {
      title: 'چگونه مطلع شوم چه دستگاه‌هایی به اکانت من متصل هستند؟',
      description:
        'برای اطلاع از لیست دستگاه‌های فعال؛ کافی است وارد بخش تنظیمات شده و از زیربخش امنیت، گزینه دستگاه‌های فعال را انتخاب نمایید. در صفحه جدید میتوانید لیست کاملی از دستگاه‌های متصل به حساب کاربری خود را مشاهده نمایید.\n' +
        '\n' +
        ' اگر دستگاهی متعلق به شما نبود و در لیست قرار داشت، می‌توانید به آسانی و با انتخاب حذف دستگاه؛ این دستگاه ناشناس را از لیست دستگاه‌های فعال حذف نمایید تا دسترسی آن به حساب کاربری شما بسته شود.\n',
    },
    q6: {
      title: 'آیا شماره تلفن من برای دیگران قابل مشاهده است؟',
      description:
        'شماره تلفن همراه شما برای هیچ کس قابل مشاهده و دسترسی نیست؛ مگر اینکه از قبل شماره تلفن همراه شما را ذخیره داشته باشند.',
    },
    q7: {
      title: 'چگونه یک کاربر را به لیست سیاه اضافه نمایم؟',
      description:
        'بعد از ورود به صفحه مکالمات با شخص مورد نظر؛ روی نام مخاطب در بالای صفحه کلیک نمایید تا صفحه پروفایل کاربر باز شود. از طریق منویی که در بالا سمت چپ باز می‌شود، می‌توانید گزینه مسدود کردن کاربر را بزنید. در ضمن از بخش حریم خصوصی صفحه تنظیمات می‌توانید، کاربران مسدود شده خود را مدیریت کنید.',
    },
    q8: {
      title:
        'چگونه دانلود خودکار تصاویر، ویدئوها، صوت، آهنگ و فایل را فعال یا غیرفعال نمایم؟',
      description:
        'برای مدیریت و کنترل دانلود خودکار، بعد از ورود به بخش تنظیمات، از زیربخش داده‌ها و ذخیره‌سازی، می‌توانید گزینه دانلود خودکار رسانه‌ها را فعال یا غیرفعال نمایید.',
    },
    q9: {
      title:
        'چگونه می توانم کش مربوط به پلتفرم پنل کاربری بنیاد شفیعی را خالی کنم؟',
      description:
        'بعد از ورود به بخش تنظیمات؛ از زیربخش داده‌ها و ذخیره‌سازی، روی گزینه پاک کردن حافظه موقت بزنید تا حافظه را حذف و خالی نمایید.',
    },
  },
  premiumFeatures: {
    weblite: 'قابلیت‌های ویژه پنل کاربری بنیاد شفیعی',
    onlineClass: {
      title: 'کلاس آنلاین',
      sub1: 'قابلیت ضبط ابری',
      sub2: 'قابلیت پخش آفلاین',
    },
    workspace: {
      title: 'فضای اختصاصی برای مجموعه‌ها و مدارس',
      sub1: 'مدیریت راحت‌تر کانال‌ها و گروه‌ها',
      sub2: 'برندینگ بهتر برای مجموعه شما',
    },
    courseVitrine: {
      title: 'فهرست دوره',
      sub1: 'مرتب سازی محتواهای کانال',
      sub2: 'دسترسی راحت‌تر مخاطبین کانال به محتواها',
    },
    submit: 'درخواست فعال‌سازی',
    callRequestSent: 'درخواست شما ثبت شده است',
  },
  premiumFeatureRequestForm: {
    title: 'درخواست فعال‌سازی',
    whoAreYou: {
      title: 'کدام گزینه شما را بهتر تعریف می‌کند؟*',
      TEACHER: 'معلم یا برگزارکننده دوره',
      INSTITUTE: 'مجموعه آموزشی یا آموزشگاه',
      SCHOOL: 'مدرسه',
    },
    yourPlan: {
      title: 'کدام یک از موارد زیر در برنامه شما وجود دارد؟*',
      ONLINE_CLASS: 'برگزاری کلاس‌های آنلاین',
      PRIVATE_CLASS: 'برگزاری کلاس‌های خصوصی',
      OFFLINE_CLASS: 'برگزاری دوره آفلاین',
      SCHOOL_ONLINE_CLASS:
        'برگزاری کلاس‌های آنلاین مدارس (ویژه تعطیلی‌های زمستان)',
    },
    askUs: 'اگر موردی وجود دارد که می‌خواهید بیان کنید بفرمایید.',
    description: 'توضیحات',
    submit: 'ارسال درخواست',
  },
  contactUs: {
    address: {
      title: 'آدرس', // TODO
      description: 'تهران، ستارخان، باقرخان، گناباد، پلاک ۴۶، واحد ۱۰',
    },
    email: {
      title: 'ایمیل', // TODO
      description: 'info@weblite.im',
    },
    phone: {
      title: 'تلفن', // TODO
      description: '02166574375',
    },
  },
  myAccountEdit: {
    save: 'حفظ ',
    pleaseSelect: 'الرجاء الإختيار ...',
    return: 'العودة',
    title: 'ویرایش پروفایل',
    base: 'پایه', // TODO
    lesson: 'درس',
    nthBaseLesson: 'درس پایه {{n}}',
    maximumBasesExceeded: 'حداکثر ۴ پایه را می‌توانید انتخاب کنید',
    maximumLessonsExceeded: 'حداکثر ۴ درس را می‌توانید انتخاب کنید',
    selectBase: 'پایه را انتخاب کنید...', // TODO
    selectYourCounty: 'استان و شهر خود را انتخاب کنید...',
    selectLesson: 'درس را انتخاب کنید...',
    selectLessonForBase: 'درس پایه موردنظر را انتخاب کنید...',
  },
  selectRole: {
    notSelected: 'مشخص نشده', // TODO
    student: 'دانش آموز',
    teacher: 'معلم یا مشاور', // ُTODO
    title: 'کدام یک شما را بیشتر توصیف می‌کند؟',
    studentDescription: 'دانش آموز، دانشجو، هنرجو',
    teacherDescription: 'معلم، مشاور، ادمین',
  },
  settings: {
    title: 'الإعدادت',
    sections: {
      notification: {
        title: 'الإشعارات',
        mute: 'كتم الإشعارات',
      },
      privacy: {
        title: 'الخصوصية',
        blockedUsers: 'المستخدمون المحظورون',
      },
      contacts: {
        sync: 'همگام سازی خودکار مخاطبین', // TODO
        repetitiveContacts: 'پیشنهاد مخاطبین پرتکرار',
        deleteSyncContacts: 'حذف مخاطبین همگام سازی شده',
        reloadContacts: 'بارگذاری مجدد مخاطبین',
      },
      storage: {
        title: 'البيانات والتخزين',
        clearStorage: 'حذف ذاكرة التخزين المؤقتة ',
        description: 'مسح البيانات التي تم تنزيلها من جهازك',
        autoDownload: 'دانلود خودکار رسانه‌ها', // add
        autoPlay: 'پخش پیوسته فایل‌های صوتی', // add
      },
      language: {
        title: 'لغة',
        selectedLanguage: 'اللغة المختارة',
        choiceLanguage: 'اختيار اللغة واختيار اللغة',
        persian: 'الفارسية',
        arabic: 'العربیة',
        english: 'إنجليزي',
      },
      security: { title: 'الأمان', activeDevices: 'الجلسات النشطة' },
    },
    privacy: {
      questions: {
        phone: 'من يستطيع رؤية رقم الهاتف الخاص بي؟',
        status: 'من يمكنه رؤية أخر ظهور لي؟',
        link_via_forward: 'من يمكنه إضافة رابط إلى حسابي عند إرسال رسائلي؟',
        image: 'من يمكنه رؤية صورتي الشخصية؟',
        add_hall: 'من يمكنه إضافتي للقنوات والمجموعات؟',
      },
      type: {
        phone: 'رقم الهاتف',
        status: 'آخر ظهور',
        link_via_forward: 'تحويل رسائلك للآخرين',
        image: 'صورة حسابك الشخصي ',
        add_hall: 'الإنضمام الى المجموعات والقنوات',
      },
      policy: {
        exceptions: (include: number, exclude: number) =>
          include || exclude
            ? ` (${exclude ? `${toLocale(exclude)}-` : ''}${
                include && exclude ? ',' : ''
              }${include ? `${toLocale(include)}+` : ''})`
            : '',
        every_body: 'الجميع',
        no_body: 'لا إحد',
        contacts: 'جهات الإتصال الخاصة بي',
      },
      exception: {
        exceptionCount: (count: number) => `${toLocale(count)} المستخدمون `,
        add: 'اضافة الإستثناءات',
        always: 'السماح دائما',
        never: 'عدم السماح أبدا',
        addUsers: 'إضافة المستخدمين',
        exceptions: 'الإستثناءات',
        set: 'تعيين الإستثناءات',
      },
    },
    deleteAccount: {
      title: 'حذف حساب المستخدم',
      description:
        'برای حذف حساب کاربری ابتدا باید کد تایید ارسال شده به تلفن همراه خود را وارد کنید.',
      confirm: 'ارسال کد تایید',
      verification: {
        title: 'کد تایید را وارد کنید',
        desc: (phone: number) =>
          `کد تایید حذف حساب کاربری به شماره ${phone} ارسال شده است`,
        confirm: 'حذف حساب کاربری',
      },
    },
    logout: 'خروج از حساب کاربری', // TODO:
  },
  privacyPolicy: {
    title: 'قوانین حریم شخصی',
    // TODO
    description0:
      'رعایت حریم شخصی کاربران برای پنل کاربری بنیاد شفیعی بسیار حائز اهمیت است. در این متن نحوۀ ذخیره‌سازی و استفادۀ پنل کاربری بنیاد شفیعی از اطلاعاتی که در نتیجه استفادۀ کاربران از خدمات پنل کاربری بنیاد شفیعی در سامانۀ پنل کاربری بنیاد شفیعی ثبت می‌شود شرح داده شده است.',
    title1: 'جمع‌آوری اطلاعات',
    description1:
      'اطلاعاتی که شما مستقیما در پنل کاربری بنیاد شفیعی ثبت می‌کنید: بخشی از اطلاعاتی که پنل کاربری بنیاد شفیعی ذخیره می‌کند اطلاعاتی است که شما به صورت مستقیم در فرآیند ثبت نام ثبت می‌کنید. این اطلاعات شامل نام، نام خانوادگی و شماره تلفن همراه می‌باشد.',
    title2: 'نحوه استفاده از خدمات',
    description2:
      'پنل کاربری بنیاد شفیعی ممکن است اطلاعات مربوط به نحوه استفاده کاربران از نرم‌افزار موبایل و سایت پنل کاربری بنیاد شفیعی را ثبت می‌کند. از این اطلاعات برای بهبود کیفیت خدمات استفاده می‌شود. اطلاعات مربوط به دستگاه مورد استفاده و شبکه اینترنت: پنل کاربری بنیاد شفیعی ممکن است اطلاعات مربوط دستگاهی که شما از طریق آن از سامانه استفاده می‌کنید (تلفن همراه، تبلت و غیره) از جمله نوع دستگاه، سیستم عامل، مشخصات سخت افزاری و همچنین اطلاعات مربوط به روش اتصال شما به اینترنت از جمله شبکه 3G، وای‌فای (WiFi) و غیره را ذخیره کند.',
    title3: 'استفاده از اطلاعات',
    description3:
      'اطلاعاتی که در پنل کاربری بنیاد شفیعی ذخیره می‌شود در موارد زیر ممکن است مورد استفاده قرار بگیرد و استفادۀ کاربر از سرویس پنل کاربری بنیاد شفیعی به منزلۀ قبول و اعطای اختیار به پنل کاربری بنیاد شفیعی جهت استفاده و بهره‌برداری از اطلاعات فوق الاشعار به شرح زیر می‌باشد: ارائه، نگهداری و بهبود کیفیت خدمات؛ شخصی‌سازی سرویس برای هر کاربر شامل ارائه پیشنهادهای ویژۀ هر کاربر؛ بدیهی است مسئولیت حفظ و نگهداری از تمامی اطلاعات فوق الاشعار برعهده پنل کاربری بنیاد شفیعی می باشد؛ به نحوی که هیچ شخص اعم از حقیقی و یا حقوقی غیر ذیصلاح حق دسترسی به اطلاعات مذکور را نخواهد داشت. صرفاً در صورتی که طبق درخواست و یا صدور دستور مقتضی از سوی مراجع قضایی، اطلاعات کاربر – اعم از اینکه به صورت مستقیم از سوی ایشان و یا به صورت خودکار جمع آوری و ضبط شده باشد – مطالبه شود، پنل کاربری بنیاد شفیعی موظف به ارایۀ اطلاعات درخواستی به مراجع مذکور خواهد بود.',
  },
  contacts: {
    add: 'إضافة جهة اتصال',
    phonePlaceholder: '۰۹xx xxx xxxx',
    editContact: 'تحرير جهة اتصال',
    newContact: 'جهة اتصال جديدة',
  },
  signin: {
    enterPhone: 'أدخل رقم الهاتف',
    confirm: 'الحصول على الرمز',
    checkboxOption: 'همگام سازی خودکار مخاطبین',
    title: `أدخل ال${APP_NAME}`,
    verification: {
      edit: 'تعديل',
      enterCode: 'أدخل الرمز المكون من ٥ أرقام الذي تم إرساله اليك',
      wrongCodeEntered: 'الرمز الذي أدخلته غير صحيح',
      maxTriesReached: 'تم اجراء اقصى حد من المحاولات, حاول مرة اخرى',
      signupClosed: 'ثبت نام بسته شده است',
      resendCode: 'إعادة إرسال رمز التحقق',
      validTillXMore: 'صالح حتی {{x}} أخرى',
      inputPlaceholder: 'رمز التحقق المكون من ٥ أرقام...',
      description: () => 'أدخل رمز التحقق الذي تلقيته عبر الرسائل القصيرة.',
      syncDeviceCode: () =>
        boldSome(
          'کد تایید به دستگاه متصلتان به ',
          '«جریان»',
          'ارسال شد لطفا آن را وارد کنید.',
        ),
    },
    serverCodes: {
      INVALID_PHONE: 'رقم الهاتف الذي ادخلته غير صحيح, يرجى المحاولة مرة اخرى',
      FAILED_DELIVERY:
        'فشل نظام الرسائل القصيرة الخاص بنا ، يرجى المحاولة مرة أخرى',
      BANNED: 'شما مجاز به ورود نیستید', // add
      NOT_INVITED: 'شما هنوز توسط شخصی دعوت نشده‌اید', // add
      NOT_IN_WHITELIST: 'شما مجوز ورود به سامانه را ندارید.', // add
    },
  },
  addAdmin: {
    title: 'إضافة مسؤول',
  },
  memberList: {
    title: 'قائمة الأعضاء',
  },
  addMembers: {
    title: 'إضافة أعضاء',
    joinedAt: {
      prefix: 'في تاريخ ',
      postfix: 'إنضم إلى ',
    },
  },
  removeMembers: {
    title: 'حذف الأعضاء',
  },
  multiSelectUserList: {
    noUserSelected: 'لم يتم تحديد المستخدم ',
  },
  admins: {
    title: 'مدراء',
    addAdmin: 'إضافة مسؤول',
    promotedBy: 'تمت ترقيته بواسطة ',
  },
  signup: {
    title: `ثبت نام در ${APP_NAME}`, // TODO
    withSigningUp: `با ثبت نام در ${APP_NAME}، شما `,
    haveReadAndAccept: 'آن را می‌پذیرید.', // TODO
    emptyName: 'لا يجب أن يكون الاسم فارغا',
    referrerCode: (optional: boolean) =>
      `کد معرف را وارد کنید (${optional ? 'اختیاری' : 'اجباری'})`,
    insertReferrerCode: 'کد معرف خود را وارد کنید',
    linkOrIdentifier: 'لینک یا آیدی کلاس',
    joiningInHall: 'در حال عضویت در کلاس',
  },
  phoneInput: {
    errorMessage: 'هذا الإدخال مطلوب',
  },
  linkInput: {
    infoMessage: 'التحقق من الاسم...',
    errorMessage: 'هذا الاسم غير صالح',
    successMessage: 'هذا الاسم صالح',
  },
  loadingModal: {
    messages: 'جار تحميل الرسائل ...',
    saveChanges: 'جارٍ حفظ التغييرات ...',
    loadFromServer: 'تلقي المعلومات من الخادم...',
    processingMessage: 'در حال پردازش پیام...', // add
    sharedMedia: 'جارٍ تحميل المحتويات...',
    wappOverlay: 'جارٍ تحضير البرنامج...',
  },
  changelogModal: {
    title: 'تغییرات نسخه جدید',
    version: 'نسخه',
    features: 'قابلیت‌های جدید',
    improvements: 'بهبود‌ها', // TODO:
    bugs: 'رفع باگ‌ها',
  },
  verificationCodeInput: {
    errorMessage: 'الرمز الذي ادخلته غير صحيح',
  },
  editUsername: {
    descriptionBox: `يجب أن يتكون الاسم من 5 أحرف على الأقل ويجب أن يبدأ بحرف إنجليزي. `,
  },
  editBio: {
    descriptionBox: 'سيتم عرض هذا النص في ملف التعريف الخاص بك.',
  },
  hallPermissionsPage: {
    common: {
      pinMessages: 'سنجاق کردن پیام‌ها', // add
      sendWapp: 'ارسال ابزار', // add
    },
    channelAdminRights: {
      title: 'صلاحيات المدير',
      subTitle: 'ماذا يفعل هذا المدير؟',
      actionButtonText: 'عزل المدير',
      secondaryButtonText: 'نقل ملكية القناة',
      changeHallInfo: 'تغيير معلومات القناة',
      editMessage: 'تحرير الرسالة',
      deleteMessages: 'احذف رسائل الآخرين',
    },
    groupMemberPermissionsOverride: {
      title: 'خيارات المستخدم',
      subTitle: 'ماذا يمكن أن يفعل هذا المستخدم؟',
      actionButtonText: 'إزالة من المجموعة',
      sendMessage: 'ارسل رسالة نصية',
    },
    groupMemberPermissions: {
      title: 'صلاحيات الأعضاء',
      subTitle: 'ماذا يمكن لأعضاء المجموعة أن يفعلوا؟',
      actionButtonText: 'عرض وضبط الاستثناءات',
      addMembers: 'أضف أعضاء جدد',
      changeHallInfo: 'تغيير معلومات المجموعة',
      sendMessage: 'ارسال پیام',
      sendMedia: 'إرسال الوسائط المتعددة',
    },
    groupAdminRights: {
      title: 'صلاحيات المدير',
      subTitle: 'ماذا يفعل هذا المدير؟',
      actionButtonText: 'عزل المدير',
      secondaryButtonText: 'نقل ملكية المجموعة',
      addNewAdmins: 'أضف مديرين جدد',
      banUsers: 'حظر المستخدمين',
      changeHallInfo: 'تغيير معلومات المجموعة',
      deleteMessages: 'حذف الرسائل',
      inviteViaLink: 'دعوة عن طريق رابط الدعوة',
    },
  },
  channel: {
    teacherTestChannelName: fullName => `دوره آنلاین استاد ${fullName}`, //  TODO:
  },
  hallSetting: {
    group: 'تنظیمات گروه',
    channel: 'تنظیمات کانال',
  },
  hallAdvancedSettings: {
    title: 'قابلیت‌های پیشرفته',
    courseVitrine:
      'ابزار نظم دهی و دسته بندی به محتواهای کانال به منظور ایجاد دسترسی بهتر',
    issue:
      'ابزار ارتباطی مخاطبین با ادمین کانال. سوالات کاربران را دریافت کنید و یا از آن‌ها سوال بپرسید.',
    forwardRestriction: {
      title: 'محدود کردن ارسال به دیگران',
      description: 'جلوگیری از ارسال محتواهای کانال به چت‌های دیگر',
    },
    watermark: {
      title: 'واترمارک متنی (شماره موبایل)',
      description: 'نمایش شماره تلفن کاربر بر روی کلاس آنلاین',
    },
    vodActivation: {
      title: 'بارگزاری ویدئو با حجم بالا',
      description:
        'بارگذاری بالای ۳۰ مگ، قفل‌گذاری و محافظت از ویدیو، امکان تنظیم کیفیت و قابلیت‌های دیگر',
    },
    userSessionsLimit: {
      title: 'تقييد عدد جلسات المستخدم',
      description: 'تقييد عدد الأجهزة التي يمكنها الوصول إلى القناة.',
    },
    hideMemberCount: {
      title: 'پنهان کردن تعداد مشترکین کانال',
      description:
        'با فعال کردن این قابلیت، کاربران کانال شما تعداد مشترکینتان را نمی‌بینند.',
    },
  },
  hallAccessibility: {
    linkPlaceHolder: 'اسم الرابط',
  },
  newChatModal: {
    newChat: 'محاثة جديدة',
    createChannel: 'إنشاء قناة',
    createGroup: 'إنشاء مجموعة',
    myContacts: 'جهات الاتصال الخاصة بي',
  },
  forceUpdateWeb: {
    title: 'بروزرسانی فوری', // TODO
    description:
      'با توجه به مشکل پیش آمده، یک بروزرسانی فوری آماده شده است. برای عدم مواجهه با مشکل، لطفا وارد نسخه جدید شوید.',
    actionButton: 'ورود به نسخه جدید',
    receivingUpdate: 'در حال دریافت نسخه جدید', // TODO
    updateReceived: 'بروزرسانی دریافت شد',
  },
  sendInviteLink: {
    title: 'ارسال لینک دعوت', // TODO
    description: (isGroup: boolean) =>
      `برخی مخاطبین، دسترسی عضویت در ${
        isGroup ? 'گروه' : 'کانال'
      } را محدود کرده‌اند. در عوض شما می‌توانید برایشان لینک دعوت ارسال کنید.`,
    shouldUnban: (count: number) =>
      `${count} نفر از افراد مسدود شده‌اند. برای عضویت آن‌ها باید ابتدا مدیر آن‌ها را رفع مسدودیت کند.`,
    inviteText: (sender: string, isGroup: boolean, inviteLink: string) =>
      `${sender} شما را برای پیوستن به ${
        isGroup ? 'گروه' : 'کانال'
      } زیر دعوت کرده است\n ${inviteLink}`,
  },

  inviteLinks: {
    common: {
      inviteLink: 'رابط الدعوة',
      expiredLink: 'انتهت صلاحية الرابط',
      oneHour: 'ساعة ۱',
      oneDay: 'يوم ۱',
      oneWeek: 'أسبوع ۱',
      unlimited: 'غير محدود',
      today: 'اليوم',
      createLink: 'إنشاء رابط',
      editLink: 'تعديل الرابط',
    },
    modal: {
      linkIsCreatedBy: 'تم انشائها من قبل ',
      joinedUser: 'عرض الأشخاص الذين انضموا من خلال الرابط',
    },
    create: {
      needsApproval: {
        title: 'تائید اعضای جدید',
        desc: 'کاربران جدید نمی‌توانند بدون تایید ادمین به کانال بپیوندند.',
      },
      timeLimit: {
        subheader: 'محدود بفترة زمنية',
        description: 'يمكنك تحديد انتهاء صلاحية الرابط بعد فترة زمنية معين',
        inputPlaceholder: 'حدد المدة الزمنية المطلوبة ',
      },
      usageLimit: {
        subheader: 'محدود بعدد المستخدمين',
        description:
          'يمكنك تحديد انتهاء صلاحية الارتباط بعد تحديد عدد معين من الاستخدامات',
        inputPlaceholder: 'حدد عدد الاستخدامات المطلوب...',
      },
    },
    list: {
      createNewLink: 'إنشاء رابط جديد',
      revoked: 'باطلة',
      isExpired: 'منتهية الصلاحية',
      limitReached: 'وصلت إلى الحد الأقصى',
      dayIsRemaining: 'ايام متبقية',
      lessThanOneDayIsRemaining: 'بقي أقل من يوم',
      noOneHasJoined: 'لم ينضم أحد',
      noOneHasJoinedYet: 'لا أحد  إنضم حتى الأن',
      oneJoined: 'انضم شخص',
      oneCanJoin: 'اشخاص يمكنهم الانضمام',
      inviteLinks: 'روابط الدعوة',
      createdLinks: 'تم إنشاء الروابط',
      revokedLinks: 'الروابط غير الصالحة',
      deleteAllRevokedLinks: 'حذف جميع الروابط غير الصالحة',
      noLink: 'لا يوجد ارتباط',
    },
  },
  chatList: {
    promoteToPremium: 'ارتقا به نسخه ویژه',
    timeToEndPremiumDemo: time => `${time} تا پایان نسخه رایگان`,
    privateSpace: 'مساحة خاصة',
    draft: 'مسودة:',
    tooManyUnseen: '۹۹+',
    menu: {
      pin: 'تثبيت',
      unPin: 'إلغاء تثبيت ',
      addHallToWorkspace: 'إضافة قناة إلى المساحة الخاصة',
      removeHallFromWorkspace: 'انتقال به چت لیست عمومی',
    },
    tabs: {
      channel: 'قناة',
      group: 'مجموعة',
      pv: 'خاصة',
      all: 'كل',
      wappRoom: 'أداة',
      workspaces: 'فضای اختصاصی',
    },
  },
  userSessionsLimit: {
    title: 'تقييد عدد جلسات المستخدم',
    description: 'تقييد عدد الأجهزة التي يمكنها الوصول إلى القناة.',

    one: 'جهاز',
    two: 'جهازين',
    three: 'ثلاثة أجهزة',
    unlimited: 'بلا حدود',
  },
  userActiveSessionsLimitModal: {
    title: 'تقييد الجهاز في هذه القناة',

    registerDescription: (limit: number) =>
      `این کانال فقط روی ${limit} دستگاه قابل استفاده است.این دستگاه را بین دستگاه‌هایی که اجازه دسترسی دارند ثبت نکرده‌اید.`,
    notAllowedDescription: (limit: number) =>
      `برای ورود به این کانال لازم است از دستگاه‌های اضافی خود خارج شوید. ورود به این کانال تنها از طریق ${limit} دستگاه امکان پذیر است.`,

    allowedDevices: 'الأجهزة المسموح بها',
    terminateSession: 'إنهاء الجلسة',
    register: 'تسجيل هذا الجهاز',
  },
  sharedMedia: {
    media: 'الإعلام',
    link: 'الرابط',
    voice: 'صوت',
    audio: 'موسیقی',
    file: 'ملف',
  },
  chatAppBar: {
    title: 'محادثة',
  },
  createHall: {
    createChannel: 'إنشاء قناة',
    createGroup: 'إنشاء مجموعة',
    createInWorkspace:
      'این کانال فقط از داخل فضای اختصاصی شما در دسترس خواهد بود و در گفتگو‌های عمومی نمایش داده نمی‌شود. پس از ایجاد کانال قابلیت جا‌به‌جایی وجود دارد.',
  },
  selectWorkspaceName: {
    title: 'ایجاد فضای اختصاصی',
    edit: 'ویرایش فضای اختصاصی',
    name: 'نام فضای اختصاصی',
    placeholder: 'نام فضای اختصاصی را وارد کنید',
    confirm: 'مرحله بعد',
  },
  selectWorkspaceColor: {
    back: 'مرحله قبل',
    confirm: 'ایجاد',
  },
  selectWorkspace: {
    title: 'فضای اختصاصی مورد نظر را انتخاب کنید',
  },
  forwardAppBar: {
    title: 'إرسال إلى...',
    receiver: (num: number) => `${toLocale(num)} المتلقي`,
  },
  chatListSearch: {
    globals: 'عمليات البحث على الصعيد الوطني',
    recent: 'مؤخرًا',
    deleteAll: 'حذف الكل',
  },
  emptyChatList: {
    title: 'سيتم عرض محادثاتك هنا',
    description: 'عن طريق الاستفادة من الزر أدناه أو من خلال البحث',
  },
  joinHallDialog: {
    joinChannel: 'انضم إلى القناة',
    joinGroup: 'الانضمام إلى المجموعة',
  },
  installTWADialog: {
    title: 'به پنل کاربری بنیاد شفیعی خوش آمدید!', // TODO
    description:
      'برای استفاده از پنل کاربری بنیاد شفیعی لطفا نسخه اپلیکیشن را نصب کنید',
    updateTitle: 'بروزرسانی جدید!', // TODO
    updateDescription:
      'نسخه جدید را می‌توانید از یکی از فروشگاه‌های زیر دریافت کنید',
  },
  emptyState: {
    noUserFound: 'المستخدم ليس موجود',
    noContactFound: `شما هنوز مخاطبی در ${APP_NAME} ندارید...`, // TODO
    noResultFound: 'لم يتم العثور على نتائج',
    noContentFound: 'لم يتم العثور على محتوى',
    searchHint: 'كن حذرًا عند إدخال الكلمات من أجل عملية بحث أفضل',
    noMessages: 'لا توجد رسائل هنا حتى الآن ...',
  },
  errorState: {
    default: 'حدث خطأ ما',
  },
  installTwa: {
    recommend: {
      // TODO
      title: 'دریافت اپلیکیشن جریان',
      description:
        'برای استفاده بهتر از پلتفرم جریان، لطفا نسخه اندروید را نصب بفرمایید.',
    },
    force: {
      title: 'دریافت اپلیکیشن جریان',
      description:
        'برای استفاده بهتر از پلتفرم جریان، باید نسخه اندروید را نصب بفرمایید.',
    },
  },
  datePickerModal: {
    inviteLinkExpireDate: {
      title: 'حدد الوقت',
    },
    birthdate: {
      title: 'اختر تأريخ الميلاد ',
    },
  },
  confirmDialog: {
    addHallToWorkspace: {
      title: 'إضافة قناة إلى المساحة الخاصة',
      description: (count: number, workspaceName: string) =>
        `آیا از افزودن ${toLocale(count)} مورد به فضای اختصاصی «${workspaceName}» اطمینان دارید؟`,
      confirmOption: 'افزودن',
      cancelOption: 'لغو',
    },
    deleteWorkspace: {
      title: 'حذف فضای اختصاصی',
      description: 'آیا از حذف فضای اختصاصی اطمینان دارید؟',
      confirmOption: 'حذف',
      cancelOption: 'لغو',
    },
    reloadContacts: {
      description: 'آیا از بارگذاری مجدد مخاطبین اطمینان دارید؟', // TODO
    },
    deleteSyncedContacts: {
      description: boldSome(
        'با این کار مخاطبین شما از سرور های جریان حذف خواهد شد . در صورتی که «',
        'همگام سازی مخاطبین',
        '» فعال باشد، دفترچه تلفن فعلی شما مجدداً همگام سازی خواهد شد.',
      ),
    },
    premiumFeatures: {
      description: n =>
        `آیا از فعال کردن ${toLocale(n)} روزه نسخه ویژه رایگان اطمینان دارید؟`,
      title: n => `${toLocale(n)} روز نسخه ویژه رایگان`,
      confirmOption: n => `شروع ${toLocale(n)} روز رایگان`,
    },
    changeChannelType: {
      title: 'تغییر نوع کانال آموزشی', // TODO
      description: 'آیا از تغییر تغییر نوع کانال آموزشی اطمینان دارید؟',
    },
    callInIos: {
      description:
        'قابلیت تماس در سیستم عامل ios پشتیبانی نمی‌شود. لطفا برای استفاده از این قابلیت، از سیستم‌عامل‌های دیگر استفاده نمایید.', // TODO
    },
    banUser: {
      description: {
        prefix: 'هل تريد الحذف ؟',
        postfix: 'هل أنت متأكد؟',
      },
      title: 'حذف المستخدم',
      cancelOption: 'الغاء',
      confirmOption: 'حذف حساب المستخدم',
    },
    deleteScheduledCall: {
      // TODO:
      title: type => `حذف ${type}`,
      description: type => `آیا از حذف این ${type} اطمینان دارید`,
      confirmOption: 'حذف',
      cancelOption: 'لغو',
    },
    deleteStory: {
      title: 'حذف اطلاع رسانی',
      description: 'آیا از حذف این اطلاع رسانی اطمینان دارید؟',
      confirmOption: 'حذف',
      cancelOption: 'لغو',
    },
    startScheduledCall: {
      // TODO:
      title: type => `شروع ${type}`,
      description: type => `آیا از شروع همین الان ${type} اطمینان دارید`,
      confirmOption: 'شروع همین الان',
      cancelOption: 'لغو',
    },
    discardChanges: {
      title: ' تطبيق التغييرات؟',
      description: 'لقد قمت بتغيير بعض الإعدادات',
      confirmOption: 'تنفيذ',
      cancelOption: 'كلا',
    },
    profile: {
      description:
        'شما برخی از اطلاعات را تغییر داده‌اید. تغییرات جدید اعمال شود؟', // TODO
      confirmOption: 'اعمال تغییرات', // TODO
    },
    addMember: {
      newMembersGreaterThan3: (text: string) => ` عضو${text}`,
      title: (count: string) => `عضو ${count}إضافة`,
      confirmOption: 'تأكيد الخيار ',
      cancelOption: 'إلغاء',
      description: {
        prefix: 'إضافة ',
        postfix: {
          prefix: 'الى',
          postfix: 'هل انت متأكد؟',
        },
      },
    },
    deleteChat: {
      title: (count: number) => `حذف ${toLocale(count)} المحادثات`,
      description: 'هل أنت متأكد أنك تريد حذف هذه المحادثات؟',
      confirmOption: 'حذف المحادثات',
    },
    deletePv: {
      title: 'حذف المحادثة',
      confirmOption: 'حذف المحادثة',
      cancelOption: 'الغاء',
      description: {
        prefix: 'هل تريد حذف المحادثه ؟',
        postfix: 'هل أنت متأكد؟',
      },
      checkboxOption: 'محو سجلك ؟',
    },
    clearPVHistory: {
      title: 'حذف السجل',
      cancelOption: 'إلغاء',
      confirmOption: 'حذف',
      description: {
        prefix: 'هل تريد حذف السجل ',
        postfix: 'هل أنت متأكد؟',
      },
      moreThan3: (text: string) => `${text} گفت‌گو`, // add
    },
    clearSearchHistory: {
      title: 'حذف السجل',
      cancelOption: 'إلغاء',
      confirmOption: 'حذف',
      description: 'هل تريد حذف السجل؟',
    },
    deleteMessage: {
      description: {
        oneMessage: () => 'هل أنت متأكد أنك تريد حذف الرسالة؟', // TODO
        manyMessage: () => 'هل أنت متأكد من حذف الرسائل المختارة؟', // TODO
        forGroup: "'برای خود و اعضای گروه '", // TODO
        forPv: (name: string) => `برای خود و ${name} `, // TODO
      },
      title: {
        oneMessage: 'حذف الرسالة',
        manyMessage: (text: string) => ` ${text}حذف الرسالة `,
      },
      cancelOption: 'إلغاء',
      confirmOption: 'حذف',
    },
    deleteContact: {
      description: 'هل تريد بالتأكيد حذف جهة الاتصال؟',
      title: 'حذف جهة الاتصال',
      cancelOption: 'إلغاء',
      confirmOption: 'حذف',
    },
    leaveHall: {
      description: {
        prefix: 'هل تغادر من',
        postfix: 'هل أنت متأكد؟',
      },
      title: (text: string) => `${text} مغادرة`,
      cancelOption: 'إلغاء',
      confirmOption: (text: string) => ` ${text} مغادرة`,
    },
    openLink: {
      title: 'هل تفتح هذا الرابط؟',
    },
    pushNotification: {
      description: 'قم بتفعيل الإشعارات ليتم إخطارك بالرسائل المرسلة إليك',
      title: 'تفعيل الإعلانات',
    },
    discardVoiceMessage: {
      title: 'حذف پیام صوتی',
      description: 'آیا میخواهید پیام صوتی خود را حذف کنید؟',
    },
    discardRecordingVoice: {
      title: 'حذف پیام صوتی',
      description:
        'آیا از متوقف کردن ضبط صدا و حذف پیام صوتی خود اطمینان دارید؟',
    },
    logout: {
      description: 'هل أنت متأكد من إنهاء هذه الجلسة؟',
      title: 'إنهاء الجلسة',
      cancelOption: 'إلغاء',
      confirmOption: 'ارسال',
    },
    terminateSessions: {
      description: 'انهاء باقي الجلسات ؟',
      title: 'إنهاء الجلسات',
      cancelOption: 'إلغاء',
      confirmOption: 'إنهاء',
    },
    deleteAccount: {
      description: 'هل أنت تريد حذف حساب المستخدم؟ ستحذف جميع المجموعات',
      title: 'حذف حساب المستخدم',
      confirmOption: 'دریافت کد تایید', // TODO
    },
    deleteHall: {
      description: (text: string) => `${text} هل انت متأكد من حذف ومغادرة؟`,
      checkboxOption: (text: string) => `لجميع الأعضاء ${text} حذف`,
      title: (text: string) => `${text} حذف`,
      cancelOption: 'إلغاء',
      confirmOption: (text: string) => `${text} حذف`,
    },
    clearDb: {
      description: 'هل أنت متأكد من مسح ذاكرة التخزين المؤقت؟',
      title: 'مسح ذاكرة التخزين المؤقت',
    },
    invite: {
      title: 'تایید دعوت',
      description: (phone: string) =>
        boldSome(
          'آیا از دعوت فردی با شماره موبایل',
          toLocale(phone),
          'مطمئن هستید؟',
        ),
      descriptions: (count: number) =>
        boldSome(
          'آیا از دعوت',
          toLocale(count),
          'نفر به این پلتفرم مطمئن هستید؟',
        ),
    }, // add
    deleteContent: {
      description: 'هل أنت متأكد من مسح هذا المحتوی؟',
    },
    deleteContentFromInline: {
      checkboxOption: 'حذف محتوای انتخاب شده از ویترین دوره', // TODO
    },
    pinMessage: {
      title: 'سنجاق کردن پیام',
      description: 'آیا می‌خواهید این پیام را به بالای گفتگو سنجاق کنید؟',
      pinForUser: (name: string) => boldSome('برای ', name, ' نیز سنجاق شود'),
      sendNotif: (isGroup: boolean) =>
        `برای اعضا ${isGroup ? 'گروه' : 'کانال'} اعلان ارسال شود`,
    }, // add
    replacePinMessage: {
      title:
        'آیا مطمئن هستید که می‌خواهید پیام جدیدی را به جای پیام قبلی سنجاق کنید؟', // add
    },
    unPinMessage: {
      title: 'برداشتن سنجاق', // add
      description: 'آیا از برداشتن سنجاق این پیام برای همه اطمینان دارید؟', // add
    },
    promoteToOwner: {
      title: 'انتقال مالکیت', // TODO:
      description: (name: string) =>
        `آیا از انتقال مالکیت این کانال به ${name} اطمینان دارید؟`, // TODO
    },
    endOngoingCall: {
      callTypes: {
        call: 'تماس با',
        group_call: 'جلسه با',
        live: 'پخش زنده',
        tribune: 'تریبون',
        classroom: 'کلاس',
      },
      title: 'تماس دیگری در جریان است',
      description: (name: string) =>
        `آیا تماس فعلی پایان یابد و تماس جدیدی با ${name} شروع شود؟`,
      confirmOption: 'بله',
    },
    disableRecentUsers: {
      // TODO
      title: 'غیر فعال کردن پیشنهاد‌ها',
      description:
        'این کار، اطلاعات مربوط به افرادی که مکررا برای آن‌ها پیام ارسال می‌کنید را در قسمت جستجو گفتگو حذف خواهد کرد.',
    },
  },
  selectMenu: {
    loading: 'در حال دریافت اطلاعات',
    nothingFound: 'موردی یافت نشد',

    county: {
      selectProvince: 'اختيار المحافظة',
      selectCounty: 'اختيار المدينة',
    },
    gender: {
      selectGender: 'اختيار الجنس',
    },
    // grade: {
    //   selectGrade: 'اختيار العام الدراسي',
    // },
  },
  message: {
    VOICE: 'رسالة صوتية',
    VIDEO: 'فيديو',
    WAPP: 'برنامج',
    FILE: 'ملف',
    IMAGE: 'صورة',
    AUDIO: 'ملف صوتي',
    CONTACT: 'جهة الإتصال', // TODO
    tool: 'أداة',
    forwardedFrom: 'محولة من ',
    repliedTo: 'در پاسخ به', // TODO
    edited: 'معدلة ',
    unreadMessages: 'رسائل غير مقروءة',
    deleted: 'الرسالة محذوفة',
    onboarding: {
      group: {
        title: (groupName: string) => `به گروه «${groupName}» خوش آمدید!`,
        actions: {
          addMember: 'افزودن عضو',
          addDescription: 'اضافه کردن توضیحات به گروه',
          shareInviteLink: 'اشتراک گذاری لینک دعوت با مخاطبینتان',
        },
        actionButtons: {
          addMember: 'افزودن اعضا',
          addDescription: 'اضافه کردن توضیحات',
          shareInviteLink: 'اشتراک گذاری لینک دعوت',
        },
        description: (actions: string[]) => {
          const actionsStr = actions.reduce((prev, current, i, arr) => {
            const or = 'یا'
            const comma = '،'
            if (!prev) return current
            if (i === arr.length - 1) return `${or} ${current}`
            return `${comma} ${current}`
          }, '')

          return `با ${actionsStr} شروع کنید!`
        },
      },
      channel: {
        title: (channelName: string) => `به کانال «${channelName}» خوش آمدید!`,
        actions: {
          addMember: 'افزودن عضو',
          addDescription: 'اضافه کردن توضیحات به کانال',
          shareInviteLink: 'اشتراک گذاری لینک دعوت با مخاطبینتان',
        },
        actionButtons: {
          addMember: 'افزودن اعضا',
          addDescription: 'اضافه کردن توضیحات',
          shareInviteLink: 'اشتراک گذاری لینک دعوت',
        },
        description: (actions: string[]) => {
          const actionsStr = actions.reduce((prev, current, i, arr) => {
            const or = 'یا'
            const comma = '،'
            if (!prev) return current
            if (i === arr.length - 1) return `${or} ${current}`
            return `${comma} ${current}`
          }, '')

          return `با ${actionsStr} شروع کنید!`
        },
      },
      pv: {
        title: 'هنوز پیامی در اینجا نیست...',
        description: 'پیامی ارسال کنید یا روی استیکر خوش آمدگویی بزنید',
      },
    },
  },
  chat: {
    issue: 'رفع اشکال',
    selectARoomToStart: 'برای شروع یکی از گفتگوها را انتخاب کنید',
    dropHereToSend: 'فایل خود را در این قسمت رها کنید', // add
    vitrine: 'ویترین', // add
    courseVitrine: 'فهرست دوره',
    generalIssue: 'پرسش و پاسخ',
    event: {
      meetingStarted: (userId: string) => [
        getUserToken(userId),
        getTextToken('جلسه را آغاز کرد'),
      ],
      liveStarted: [getTextToken('پخش زنده شروع شد')],
      classStarted: () => [getTextToken('کلاس آنلاین شروع شد')],
      tribuneStarted: [getTextToken('تریبون شروع شد')],
      joinedGroupViaLink: (userId: string) => [
        getTextToken('انظم '),
        getUserToken(userId),
        getTextToken(' إلى المجموعة عن طريق رابط الدعوة'),
      ],
      joinedGroup: (userId: string) => [
        getTextToken('انضم '),
        getUserToken(userId),
        getTextToken(' إلى المجموعة'),
      ],
      leaveGroup: (userId: string) => [
        getTextToken('غادر '),
        getUserToken(userId),
        getTextToken(' المجموعة'),
      ],
      signUpContact: (userId: string) => [
        getTextToken('انضم '),
        getUserToken(userId),
        getTextToken(' الی النهچ'),
      ],
      addToGroup: (
        doerUserId: string,
        affectedUserId: string,
        isGroup: boolean,
      ) => [
        getUserToken(doerUserId),
        getTextToken('قام بإضافة'),
        getUserToken(affectedUserId),
        getTextToken(` الی ${isGroup ? 'المجموعة' : 'قناة'}`),
      ],
      removeFromGroup: (
        doerUserId: string,
        affectedUserId: string,
        isGroup: boolean,
      ) => [
        getUserToken(doerUserId),
        getTextToken('قام بحذف'),
        getUserToken(affectedUserId),
        getTextToken(` من ${isGroup ? 'المجموعة' : 'قناة'}`),
      ],
      pinnedMessage: (userId: string, messageIid: number) => [
        getUserToken(userId),
        getTextToken(' «'),
        getMessageToken(messageIid),
        getTextToken(userId ? '» را سنجاق کرد' : '» سنجاق شد'), // add
      ],
      youJoinedChannel: 'شما به این کانال پیوستید', // TODO:
    },
    // TODO: CHECK THIS FORM OF LOCALIZATION
    meetingStarted: 'جلسه را آغاز کرد',
    meetingEnded: 'جلسه به پایان رسید',
    liveStarted: 'پخش زنده شروع شد',
    classStarted: 'کلاس آنلاین شروع شد',
    liveEnded: 'پخش زنده به پایان رسید',
    classEnded: 'کلاس آنلاین به پایان رسید',
    tribuneStarted: 'تریبون شروع شد',
    tribuneEnded: 'تریبون به پایان رسید',
    joinedGroupViaLink: (name: string) => `انظم${name} عن طريق رابط الدعوة `,
    signUpContact: 'إنظم الى نهج',
    joinGroup: 'انضم إلى المجموعة ',
    leaveGroup: 'غادر المجموعة',
    sendVoiceDialog: {
      title: 'پیام صوتی',
    },
    addToGroup: (
      isGroup: boolean,
      doerUserName: string,
      affectedUserName: string,
    ) =>
      `${doerUserName} قام بإضافة ${affectedUserName} الى ${
        isGroup ? 'المجموعة' : 'قناة'
      }`,
    // `${affectedUserName} توسط ${doerUserName} به ${
    //   isGroup ? 'گروه' : 'کانال'
    // } اضافه شد`,
    removeFromGroup: (
      isGroup: boolean,
      doerUsername: string,
      affectedUsername: string,
    ) =>
      `${doerUsername} قام بحذف ${affectedUsername} الى ${
        isGroup ? 'المجموعة' : 'قناة'
      }`,
    // `${affectedUsername} توسط ${doerUsername} از ${
    //   isGroup ? 'گروه' : 'کانال'
    // } حذف شد`,
    pinnedMessage: (doerUserName: string, message: string) =>
      `${doerUserName || ''} «${message}» ${
        doerUserName ? 'را سنجاق کرد' : 'سنجاق شد'
      }`, // add
    createHall: 'إنشاء قاعة',
    removeHallImage: (isGroup: boolean) =>
      `تم حذف صورة ${isGroup ? 'المجموعة' : 'قناة'}`,
    // `عکس ${isGroup ? 'گروه' : 'کانال'} پاک شد`,
    changeHallImage: (isGroup: boolean) =>
      `تم تغيير صورة ${isGroup ? 'المجموعة' : 'قناة'}`,
    // `عکس ${isGroup ? 'گروه' : 'کانال'} تغییر کرد`,
    changeHallName: (isGroup: boolean, hallNewName: string) =>
      `تم تغيير اسم ${isGroup ? 'المجموعة' : 'قناة'} الى «${hallNewName}»`,
    // `نام ${isGroup ? 'گروه' : 'کانال'} به «${hallNewName}» تغییر کرد`,
    typing: 'يكتب',
    recordingVoice: 'تسجيل الصوت...',
    uploadingVoice: 'جاٍ تحميل صوت ...',
    uploadingVideo: 'جارٍ تحميل فيديو ...',
    uploadingFile: 'جارٍ تحميل ملف ...',
    uploadingPhoto: 'جارٍ تحميل صورة ...',
    uploadingAudio: 'جارٍ تحميل ملف صوتي ...',
    tooManyOtherPeople: ' وعدد من الاخرين...',
    editMessage: 'تحرير الرسالة',
    sendField: 'اكتب رسالة...',
    sendFieldCaption: 'كتابة وصف ',
    sendImage: 'إرسال صورة',
    sendVideo: 'إرسال فيديو',
    editImage: 'تحرير الصورة',
    editVideo: 'تحرير الفيديو',
    recording: 'تسجيل',
    processing: 'در حال پردازش',
    replaceFile: 'استبدال الملف ',
    replacement: 'إستبدال',
    mute: 'كتم الصوت',
    unMute: 'الغاء الكتم',
    pinned: 'پیام سنجاق شده', // add
    aMessage: 'یک پیام', // add
    forward: 'ارسال', // TODO:
    compressing: 'در حال فشرده‌سازی', // TODO:
  },
  sendField: {
    brightness: 'آشکارسازی', // TODO
    contrast: 'کنتراست',
    saturation: 'شدت رنگ',
    hue: 'طیف رنگ', // TODO
    refresh: 'بازنشانی',
    upperQuality: 'کیفیت بالاتر', // TODO
    lessVolume: 'حجم کمتر',
  },
  feedbackDetailsDialog: {
    title: 'ثبت بازخورد',
    inputLabel: 'به چه مشکلی برخورد کردید؟',
    inputPlaceholder: 'توضیحات خودتان را وارد کنید',
  },
  requestToJoinHallDialog: {
    confirmText: 'ارسال درخواست عضویت',
    description: type =>
      `این ${
        type === 'CHANNEL' ? 'کانال' : 'گروه'
      } فقط پس از تایید توسط ادمین مشترک جدید می‌پذیرد`,
    subtitle: type => `${type === 'CHANNEL' ? 'کانال' : 'گروه'} خصوصی`,
  },
  callRoomIsFullDialog: {
    title: callName => `ظرفیت ${callName} تکمیل است`,
    description: callName =>
      `متأسفانه ظرفیت این ${callName} به حد نصاب رسیده و در حال حاضر امکان ورود وجود ندارد.`,
    submitText: 'متوجه شدم',
  },
  call: {
    connecting: 'در حال برقراری ارتباط...',
    incomingCall: 'تماس سحاب...', // TODO
    ongoingCalls: {
      call: 'تماس در جریان',
      meeting: 'جلسه در جریان',
      live: 'پخش زنده در جریان',
      tribune: 'تریبون در جریان',
      classroom: 'کلاس آنلاین در جریان',
    },
    voiceCall: 'گفتگوی صوتی',

    group_call: 'جلسه',
    live: 'پخش زنده',
    tribune: 'تریبون',
    call: 'تماس',
    classroom: 'کلاس آنلاین',
    class: 'کلاس',

    watch: 'مشاهده',
    join: 'پیوستن',
    enter: 'ورود',
    leave: 'ترک',
    notification: 'اطلاع رسانی',
    startNow: 'شروع همین الان',

    startsAtDate: 'برگزاری در ',
    startsFrom: 'تا شروع',
    inProgress: 'در حال برگزاری',

    cancel: 'انصراف',
    accept: 'پذیرفتن',
    reject: 'رد کردن',
    retry: 'تلاش مجدد',
    callAgain: 'تماس مجدد',

    busy: 'خط مشغول است',
    ended: 'مکالمه تمام شد',
    rejected: 'رد تماس توسط مخاطب',
    'timed-out': 'مخاطب در دسترس نیست',
    canceled: 'لفو تماس توسط مخاطب',
    scheduledCallNotificationMessage: (
      type,
      startsAt,
      _roomType,
      name,
      // inviteLink,
    ) => `
    ${type} با عنوان ${name} در ${startsAt} برگزار خواهد شد.
    `,
    scheduledCallEventMessage: (
      callType: string,
      date: string,
      userName?: string,
    ) =>
      userName
        ? `${userName} ${callType} را برای تاریخ ${date}، زمان بندی کرد`
        : `${callType} برای تاریخ ${date}، زمان بندی شد`, //  TODO:

    callFeedbackDialog: {
      title: (callTypeString: string, callType: string) =>
        `به کیفیت ${
          callType === 'tribune' ? 'صدا' : 'صدا و تصویر'
        } در این ${callTypeString} چه نمره‌ای می‌دهید؟`, // TODO
      qualityDescriptors: {
        veryBad: 'خیلی بد',
        bad: 'بد',
        normal: 'معمولی',
        good: 'خوب',
        veryGood: 'خیلی خوب',
      },
      problems: {
        title: 'مشکل کجا بود؟',
        noImage: 'تصویر را نداشتم',
        disconnectingAndConnectingTheImage: 'قطع و وصلی تصویر',
        noAudio: 'صدا را نداشتم',
        disconnectingAndConnectingTheAudio: 'قطع و وصلی صدا',
      },
      inputPlaceholder: 'مشکل خودتان را در صورت لزوم توضیح دهید',
      confirm: 'تایید',
    },

    status: {
      common: {
        busy: 'تماس ناموفق',
        rejected: 'تماس رد شد',
        canceled: 'تماس لغو شده',
      },
      opponent: {
        successful: 'تماس دریافتی',
        'timed-out': 'عدم پاسخگویی',
      },
      me: {
        successful: 'تماس موفق',
        'timed-out': 'تماس از دست رفته',
      },
    }, // TODO
  },
  accounts: {
    deletedAccount: 'تم حذف حساب المستخدم',
    deletedAccountAvatarText: 'ح‌ح',
    recentUserDeletedAccount: 'حساب محذوف',
  },
  contextMenu: {
    limitedByAdmin: (isGroup: boolean) =>
      `قابلیت کپی و ارسال به دیگران در ${
        isGroup ? 'گروه' : 'کانال'
      } توسط ادمین بسته شده است`,
    reply: 'الرد',
    forward: 'تحويل ',
    copyLink: 'نسخ الرابط',
    saveToDownloads: 'حفظ في التنزيلات',
    showSharedMedia: 'عرض الوسائط المشتركة',
    haveSeen: (count: number) =>
      count > 1
        ? `${toLocale(count)} نفر دیده‌اند ` // TODO
        : `${toLocale(1)} نفر دیده است `, // TODO,

    openInWappDevEnv: 'توسعه وپ',
  },
  forceUpdateTwa: {
    title: `بروزرسانی جدید ${APP_NAME}`, // TODO
    description:
      'نسخه فعلی دیگر پشتیبانی نمی‌گردد، لطفا نسخه جدید را دریافت و نصب کنید.',
    button: 'دریافت نسخه جدید',
  },
  validation: {
    invitationLink: {
      leastChars: 'يجب ألا يقل طول رابط الدعوة عن ۵ أحرف',
      notSupportedChars:
        'يسمح فقط بإدخال الحروف و الاعداد الانجليزية و علامة _ ',
      notStartWithLetter: 'يجب أن يبدأ رابط الدعوة بحرف ',
      exists: 'رابط الدعوة الذي تم إدخاله مكرر',
      isAvailable: 'رابط الدعوة هذا متاح',
    },
    username: {
      leastChars: 'يجب أن يتكون اسم المستخدم من ۵ أحرف على الأقل.',
      notSupportedChars:
        'يسمح فقط بإدخال الحروف و الاعداد الانجليزية و علامة _ ',
      notStartWithLetter: 'يجب أن يبدأ اسم المستخدم بحرف',
      exists: 'اسم المستخدم الذي تم إدخاله مكرر',
      isAvailable: 'إسم المستخد هذا متاح',
    },
  },
  snackbar: {
    failedToLoadUserWorkspaces: 'دریافت فضای اختصاصی با مشکل مواجه شد',
    hallsMovedToWorkspace: 'گفت‌وگوها با موفقیت به فضای اختصاصی منتقل شدند',
    hallsRemovedFromWorkspace: 'گفت‌وگوها با موفقیت از فضای اختصاصی حذف شدند',
    phoneNumberIsNotSignedUp: 'رقم الهاتف المحمول الخاص بك غير مسجل',
    workspaceUpdated: 'فضای اختصاصی با موفقیت به روز شد',
    workspaceDeleted: 'فضای اختصاصی با موفقیت حذف شد',
    workspaceCreated: 'فضای اختصاصی با موفقیت ایجاد شد',
    trialIsActivatedOnce: 'نسخه آزمایشی پیش از این برای شما فعال شده است.',
    trialCantBeActivatedBecauseOfActivatedPlans:
      'با توجه به خرید بسته های پنل کاربری بنیاد شفیعی امکان فعال سازی نسخه آزمایشی وجود ندارد.',
    callRoomIsFull: (callType: string) => `ظرفیت ${callType} تکمیل شده است`,
    trialStartedSuccessfully: 'دموی نسخه ویژه برای شما فعال شد.',
    failedToStartTrial:
      'فعال‌سازی نسخه آزمایشی با مشکل مواجه شد. لطفا مجددا تلاش کنید',
    requestForPremiumPlanSentSuccessfully:
      'درخواست شما ثبت شده است. \n' +
      'بزودی کارشناسان ما با شما ارتباط میگیرند.',
    yourTrialHasExpired: 'مدت استفاده رایگان شما  تمام شده است',

    invite: {
      error: {
        FORBIDDEN: 'شما اجازه‌ی دعوت ندارید',
        EXCEEDS_CAPACITY: 'تعداد شماره‌ها بیشتر از ظرفیت دعوت شماست',
      },
      successfully: (invited: string, registered: string) =>
        `${invited ? `${invited} نفر با موفقیت دعوت شدند.` : ''}  ${
          registered
            ? `${registered} نفر از افرادی که دعوت کردید پیش از این ثبت نام کرده بودند.`
            : ''
        }`,
      noOneInvited: 'هیچ دعوتی با موفقیت انجام نشد',
    },
    switchSyncContactActivation: (activated: boolean) =>
      `مخاطبین این دستگاه به این حساب کاربری اضافه ${
        activated ? 'خواهد' : 'نخواهد'
      } شد.`,
    couldntJoinClass:
      'در پیوستن به کلاس مشکلی پیش آمده است. لطفا دوباره تلاش کنید.',
    inviteLinkSentSuccessfully: 'لینک دعوت برای مخاطبین ارسال شد',
    joinRequestSentSuccessfully: 'درخواست عضویت با موفقیت ارسال شد',
    youHaveAlreadyRequestedToJoin: 'شما قبلاً درخواست عضویت داده‌اید',
    joinRequestAccepted: userName => `${userName} با موفقیت به کانال پیوست`,
    joinRequestRejected: userName => `درخواست ${userName} رد شد`,
    failedToAcceptJoinRequest: userName =>
      `تایید درخواست عضویت ${userName} با مشکل مواجه شد`,
    failedToRejectJoinRequest: userName =>
      `رد درخواست عضویت ${userName} با مشکل مواجه شد`,
    incomingCallAcceptedFromAnotherDevice:
      'تماس از یک دستگاه دیگر شما پاسخ داده شد.',
    invalidStoryFileType:
      'نوع فایل انتخابی شما برای اطلاع رسانی پشتیبانی نمی‌شود',
    usernameIsInvalid: 'نام کاربری مورد نظر پیدا نشد', // TODO
    maxCharacterInTextMessageReached:
      'شما به بیشترین حد استفاه از کاراکتر در یک پیام متنی رسیده‌اید.', // TODO
    maxCharacterInCaptionReached:
      'شما به بیشترین حد استفاه از کاراکتر در یک زیرمتن رسیده‌اید.',
    syncedContactsClearedSuccessfully: 'مخاطبین شما حذف شد', // TODO
    maximumNumberOfHallAdminsExceeded: limit =>
      `حداکثر ${limit} نفر میتوانند مدیر باشند.`,
    reloadingContactsInProgress: 'در حال بروزرسانی مخاطبین',
    ContactsReloadedSuccessfully: 'بروزرسانی مخاطبین با موفقیت انجام شد',
    noForwardPermission: {
      text: 'شما اجازه ارسال به این چت را ندارید', // TODO
    },
    fileMessageSizeLimitExceeded: maximumSize =>
      `حجم فایل ارسالی نمیتواند بیشتر از ${maximumSize} مگابایت باشد!`, // TODO
    call: {
      userBanned: (callType: string) =>
        `دسترسی شما به این ${callType} ممنوع شده است`,
      requestFailed: 'درخواست شما با مشکل مواجه شد. لطفا دوباره تلاش کنید.',
      joinFailed: (callType: string) =>
        `در پیوستن به ${callType} مشکلی پیش آمده است. لطفا دوباره تلاش کنید.`,
      roomIsFull: `متاسفانه ظرفیت کلاس به اتمام رسیده است`, // TODO
      startFailed: (callType: string) =>
        `شروع ${callType} با مشکل مواجه شد. لطفا دوباره تلاش کنید.`,
      noInternetConnection: 'لطفا اتصال اینترنت خود را بررسی کنید.',

      edited: type => `${type} با موفقیت ویرایش شد`,
      deleted: type => `زمان‌بندی ${type} حذف شد`,
    },
    noPermissionToSend: {
      text: 'شما اجازه ارسال پیام در این گفت‌و‌گو را ندارید', // TODO
    },
    identifierNotExist: {
      text: 'شناسه مورد نظر وجود ندارد', // TODO
    },
    connectionProblem: {
      text: 'هناك مشكلة في الاتصال بالخادم',
    },
    genImageFailed: {
      text: 'تولید تصویر موردنظر با مشکل مواجه شده است',
    },
    genTextFailed: {
      text: 'تولید متن موردنظر با مشکل مواجه شده است',
    },
    operationFailed: {
      text: 'مشکلی در انجام عملیات رخ داده است',
    },
    newUpdateIsAvailable: {
      text: 'التحديث الجديد متاح!',
      actionText: 'اعداد',
    },
    installPWAPrompt: {
      text: 'نصب اپلیکیشن',
      actionText: 'دریافت',
    },
    thereIsAProblemInConnection: {
      text: 'توجد مشكلة في الاتصال',
    },
    inviteLinkExpired: {
      text: 'رابط الدعوة منتهي الصلاحية ',
    },
    invalidLink: {
      text: 'الرابط غير صحيح',
    },
    nMemberRemovedFromHall: {
      text: (count: string, type: string) => `${count} عضو از ${type} حذف شد`,
    },
    canNotAccessViaForwardedMessage: {
      text: 'تم إخفاء الحساب من قبل المستخدم',
    },
    historyWasCleared: {
      text: 'تم مسح سجل محفوظات المحادثة',
    },
    chatsRemoved: {
      text: 'تم حذف المحادثات',
    },
    chatRemoved: {
      text: 'تم حذف المحادثة',
    },
    textSavedInMemory: {
      text: 'تم حفظ النص في الالذاكرة',
    },
    linkSavedInMemory: {
      text: 'تم حفظ الرابط في الذاكرة',
    },
    hashtagSavedInMemory: {
      text: 'تم حفظ الوسم في الذاكرة',
    },
    phoneNumberSavedInMemory: {
      text: 'رقم الهاتف المحمول المحفوظ في الذاكرة',
    },
    reportSent: {
      text: 'تم تسجيل التقرير بنجاح',
    },
    bioSavedInMemory: {
      text: 'التعريف القصير محفوظ في الذاكرة',
    },
    usernameSavedInMemory: {
      text: 'اسم المستخدم محفوظ في الذاكرة',
    },
    userBanned: {
      text: 'تم حظر المستخدم',
    },
    userUnbanned: {
      text: 'تم إلغاء حظر المستخدم',
    },
    uploadingImage: {
      text: 'يتم تحميل الصورة',
    },
    userRemovedFromYourContact: {
      text: {
        postfix: 'تمت إزالته من جهات الاتصال الخاصة بك',
      },
    },
    userPromotedToAdmin: {
      text: {
        postfix: 'تمت ترقيته إلى منصب مدير',
      },
    },
    userRemovedFromRoom: {
      text: {
        postfix: {
          prefix: 'من',
          postfix: 'تم الحذف',
        },
      },
    },
    nMessageForwardedToChat: {
      text: (multipleMessage: boolean, count: string) =>
        `تم ارسال الرسالة الى ${count} المحادثة`,
    },
    selectionLimit: {
      text: (count: number) =>
        `انتخاب بیشتر از ${toLocale(count)} نفر مجاز نیست`,
    }, // add
    sharedSuccessfully: 'پیام شما با موفقیت ارسال شد', // add
    pinnedSuccessfully: 'پیام سنجاق شد', // add
    unPinnedSuccessfully: 'سنجاق پیام برداشته شد', // add
    messageNotExist: 'پیام وجود ندارد', // add
    pinRoomLimit: {
      text: `متاسفانه نمیتوانید بیش از ${toLocale(
        LIMITS.pinnedRoomsCount,
        false,
      )} گفت‌وگو را سنجاق کنید`,
    },
  },
  roomPins: {
    pinned: (count: number) => `${toLocale(count)} پیام سنجاق شده`, // TODO
    removeAllPins: 'برداشتن سنجاق تمامی پیام‌ها',
  },
  activeSessions: {
    currentDevice: 'الجهاز الحالي',
    deactivateOtherDevices: 'إلغاء تنشيط الأجهزة الأخرى',
    otherActiveDevices: 'أجهزة نشطة أخرى',
    // getTextToken('انظم '),
    unknownInformation: 'معلومات غير معروفة',
    terminateSession: 'إنهاء الجلسة',
  },
  invalidLinkModal: {
    title: 'لینک کلاس اشتباه است',
    description: 'لینک کلاس وارد شده معتبر نمی‌باشد. لطفا دوباره تلاش کنید.',
    confirmText: 'تغییر لینک',
    cancelText: 'رد کردن',
  },
  iosCallProblemsModal: {
    description:
      'کاربر عزیز، با توجه به سیستم عامل گوشی شما (iOS) ممکن است که این سامانه با مشکلاتی مواجه شود. آیا از ورود به این سامانه اطمینان دارید؟',
    confirmText: 'ورود به نسخه آزمایشی',
  },
  chooseChannelCallModal: {
    title: 'نوع ابزار ارتباطی را انتخاب کنید:',
    groupCallDescription: 'برگزاری جلسات گروهی',
    liveDescription: 'برگزاری رویدادهای تصویری',
    tribuneDescription: 'برگزاری رویدادهای صوتی',
    classroomDescription: 'برگزاری کلاس آنلاین',
    callLimit: (limit: number) => `محدودیت: ${toLocale(limit)} نفر`,
  },
  chooseHallCallTimeModal: {
    creatingCall: {
      tribune: 'برگزاری تریبون',
      meeting: 'برگزاری جلسه',
      live: 'برگزاری پخش زنده',
      classroom: 'برگزاری کلاس آنلاین',
    },
    editingCall: {
      tribune: 'ویرایش زمانبندی تریبون',
      meeting: 'ویرایش زمانبندی جلسه',
      live: 'ویرایش پخش زمانبندی زنده',
      classroom: 'ویرایش زمانبندی کلاس آنلاین',
    },
    schedulingCall: {
      tribune: 'زمانبندی تریبون',
      meeting: 'زمانبندی جلسه',
      live: 'زمانبندی پخش زنده',
      classroom: 'زمانبندی کلاس آنلاین',
    },
    titleError: {
      tribune: 'عنوان تریبون نمی‌تواند کمتر از ۳ کاراکتر باشد.',
      group_call: 'عنوان جلسه نمی‌تواند کمتر از ۳ کاراکتر باشد.',
      live: 'عنوان پخش زنده نمی‌تواند کمتر از ۳ کاراکتر باشد.',
      classroom: 'عنوان کلاس آنلاین نمی‌تواند کمتر از ۳ کاراکتر باشد.',
    },
    title: 'عنوان',
    titlePlaceholder: 'عنوان را وارد کنید',
    startTime: 'زمان شروع',
    selectStartTime: 'انتخاب زمان شروع',
    sendNotificationInChannel: 'ارسال پیام اطلاع‌رسانی در کانال',
    sendNotificationInGroup: 'ارسال پیام اطلاع‌رسانی در گروه',
    delete: 'حذف',
    save: 'ذخیره',
    start: 'شروع',
    startNow: 'شروع همین الان',
    scheduleForLater: 'زمان بندی برای بعد',
    startAtChosenDate: 'شروع در زمان انتخاب شده',
    optional: 'اختیاری',
  },
  toolBoxModal: {
    contact: 'جهة الإتصال',
    header: 'أدوات',
    actions: {
      image: 'عکس',
      video: 'ویدیو',
      file: 'فایل',
      location: 'موقعیت',
      contact: 'جهة الإتصال',
    },
  },
  shareWappModal: {
    shareInSahab: 'أرسل للآخرين في نهج',
    shareOutOfSahab: 'انشر على الشبكات الاجتماعية الأخرى',
    copy: 'نسخة من الرابط المباشر',
  },
  seenListModal: {
    today: 'امروز در ', // TODO:
    yesterday: 'دیروز در ',
    customDate: (date: string, time: string) => `
      ${date} در ${time}
    `,
  },
  bookmarkModal: {
    management: 'إدارة',
    bookmark: 'إظهار',
    bookmarked: 'ظاهر',
    report: 'تقرير',
    remove: 'حذف المحتوى',
    edit: 'تعديل المحتوى',
  },
  bookmarkSelectionListModal: {
    noList: 'لا توجد قوائم',
    shouldMakeAList: 'قم بإنشاء قائمة لإضافة محتوى',
    contentCount: (count: number) => `${toLocale(count)} محتوی`,
    noContent: 'لا يوجد محتوى',
    createCollection: 'إنشاء قائمة',
    editCollection: 'تعديل القائمة',
    add: 'اضافة',
  },
  bookmarkMakeListModal: {
    title: 'عنوان القائمة',
    placeholder: 'أدخل عنوان القائمة',
    shouldNotBeEmpty: 'أدخل عنوان القائمة',
  },
  permissionModal: {
    mic: 'میکروفون', // TODO:
    camera: 'دوربین', // TODO:
    notifications: 'اعلان‌ها', // TODO:
    contacts: 'مخاطبان', // TODO:
    promptTitle: (name: string) => `دسترسی برای ${name}`,
    deniedTitle: (name: string) => `عدم دسترسی به ${name}`,
    promptDescription: (name: string) =>
      `به منظور فعال‌سازی ${name}، روی ادامه زده و بعد گزینه allow رو انتخاب کنید`,
    deniedDescription: (name: string) =>
      `شما مجوز دسترسی به ${name} را به سحاب نداده‌اید. برای راهنمایی بیشتر به منظور فعال کردن ${name}، روی اطلاعات بیشتر بزنید.`,
    infoOption: 'اطلاعات بیشتر', // TODO
    updateTwaVersion: {
      title: 'انتشار نسخه جدید اندروید', // TODO
      description:
        'نسخه جدید اندروید منتشر شده است، همین الان آن را دریافت و نصب کنید!', // TODO
      confirmOption: 'دریافت و نصب', // TODO
      cancelOption: 'بعدا', // TODO
    },
    clockMismatch: {
      title: 'عدم تطابق ساعت', // TODO
      description:
        'کاربر عزیز، ساعت دستگاه شما مطابق با ساعات رسمی کشور نیست و نیازمند اصلاح است. برای دیدن نحوه اصلاح آن، وارد لینک زیر شوید.', // TODO
    },
    notification: {
      teacher: {
        title: 'در جریان همه اتفاقات قرار بگیرید!',
      },
      student: {
        // TODO
        title: 'هیچ اعلانی را از دست ندهید!',
      },
      description:
        'برای دسترسی به تمامی امکانات این برنامه، در پنجره‌ باز شده در ادامه، گزینه "Allow" را بزنید',
      activate: 'فعال کردن اعلان‌ها',
    },
    notYet: 'فعلا نه', // TODO
    contact: {
      teacher: {
        title: 'دوستان و آشنایان خود را پیدا کنید!',
      }, // TODO
      student: {
        title: 'هم‌کلاسی‌ها و معلم‌های خودت رو پیدا کن!',
      },
      description:
        'برای دسترسی به به لیست مخاطبین خود، در پنجره باز شده در ادامه، گزینه "Allow" را بزنید',
      activate: 'اجازه دسترسی به مخاطبین',
    },
  },
  premiumFeatureModal: {
    buy: 'خرید بسته ویژه',
    testFreeForNDays: (n: number) => `${toLocale(n)} روز رایگان امتحان کنید`,
    features: {
      All: {
        title: 'نسخه ویژه',
        description:
          'همه نیازهای آموزشی شما در یک پلتفرم جامع کلاس آنلاین، دوره ویدیوئی، آزمون و ...',
      },
      CourseVitrine: {
        title: 'ابزار فهرست دوره',
        description: 'فعال کردن فهرست تنها توسط کاربران ویژه امکان پذیر است.',
      },
      QuestionAndAnswer: {
        title: 'ابزار پرسش',
        description: 'فعال کردن پرسش تنها توسط کاربران ویژه امکان پذیر است.',
      },
      ProtectContent: {
        title: 'محدود کردن ارسال به دیگران',
        description:
          'فعال کردن محدودیت ارسال تنها توسط کاربران ویژه امکان پذیر است.',
      },
      Classroom: {
        title: 'ابزار کلاس آنلاین',
        description:
          'برای استفاده از کلاس آنلاین، لازم است کاربری ویژه خریداری کنید.',
      },
      Story: {
        title: 'اطلاع رسانی',
        description:
          'برای استفاده از اطلاع رسانی در کانال، لازم است کاربری ویژه خریداری کنید.',
      },
      UserStory: {
        title: 'اطلاع رسانی',
        description:
          'برای استفاده از اطلاع رسانی، لازم است کاربری ویژه خریداری کنید.',
      },
      VodActivated: {
        title: 'بارگزاری ویدئو با حجم بالا',
        description:
          'برای استفاده از بازگزاری ویدیو با حجم بالا، لازم است کاربری ویژه خریداری کنید.',
      },
      HideMemberCount: {
        title: 'پنهان کردن تعداد مشترکین کانال',
        description:
          'برای پنهان کردن تعداد مشترکین کانال، لازم است کاربری ویژه خریداری کنید.',
      },
      UserSessionsLimit: {
        title: 'محدودیت تعداد نشست کاربران',
        description:
          'برای محدود کردن تعداد نشست کاربران، لازم است کاربری ویژه خریداری کنید.',
      },
      Recording: {
        title: 'قابلیت ضبط',
        description:
          'برای فعال سازی قابلیت ضبط، لازم است کاربری ویژه خریداری کنید.',
      },
      Vod: {
        title: 'دوره آفلاین',
        description:
          'برای برگزاری دوره‌های آفلاین، لازم است کاربری ویژه خریداری کنید.',
      },
      Workspace: {
        title: 'ایجاد فضای اختصاصی',
        description:
          'امکان ایجاد یک محیط آموزشی منحصر به فرد و متناسب با نیازهای خاص شما.',
      },
    },
  },
  startPremiumFeaturesTrialModal: {
    description:
      'همه نیازهای آموزشی شما در یک پلتفرم جامع کلاس آنلاین، دوره ویدیوئی، آزمون و ...',
    confirmText: 'شروع دمو',
    imageAlt: 'فعالسازی دمو',
  },
  wapps: {
    usageDashboard: 'مصرف اشتراک',
    post: 'پست',
    poll: 'نظرسنجی',
    form: 'فرم',
    multipleChoiceExam: 'آزمون تستی',
    descriptiveExam: 'آزمون تشریحی',
    unitTest: 'تک تست',
    homework: 'تکلیف',
    article: 'مقاله',
    kaghaz: 'کاغذ',
    darsnameh: 'درسنامه',
    rooznegar: 'روزنگار',
    generalExam: 'آزمون عمومی',

    // generalExam: 'الامتحان الاختباري',
    generalExam: 'الامتحان',
    wappDevEnv: 'محیط توسعه وپ',
    // generalDescriptiveExam: 'الامتحان الوصفي',
    // homework: 'واجب بيتي',
    blog: 'بلاگ',
    // darsNameh: 'مناهج',
    event: 'رویداد', // add
    multimedia: 'آثار', // add
    forum: 'هم‌اندیشی', // add
    tribune: 'تریبون', // add
    rahkar: 'راهکار', // todo
    meeting: 'اجتماع',
    unknown: 'أداة',
    map: 'موقعیت',
    nevise: 'مدونة',
    issue: 'رفع اشکال',
  },
  chatListToolbox: {
    title: 'جعبه ابزار',
    otherWapps: 'سایر ابزارها',
    wappDescription: {
      generalExam: 'برگزاری آزمون تستی تک درس، چند درس و جامع',
      unitTest: 'ابزاری حرفه‌ای برای ارسال تست های چند گزینه‌ای',
      poll: 'مناسب برای ایجاد انواع نظرسنجی چندگزینه‌‌ای',
      wappDevEnv: 'محیطی برای توسعه وپ‌ها و تست قابلیت‌های ارائه‌شده به آن‌ها',
    },
  },
  emojiPicker: emojiPickerI18n,
  errorBoundary: {
    applicationCrashed: 'البرنامج يواجه مشكلة!',
    tryAgainOrCallSupport:
      'للأسف هنالك خطأ في الصفحة التي دخلتها، انقر فوق زر الرجوع للمتابعة',
    contactSupport: 'ارتباط با پشتیبانی', //  TODO:
  },
  warningPages: {
    browserNotSupported: {
      // TODO
      title: 'مرورگر نامناسب',
      useSafari: {
        text1:
          'مرورگری که از آن استفاده می‌کنید پشتیبانی نمی‌شود. برای جلوگیری از مشکلات احتمالی، از مرورگر سافاری',
        text2: 'استفاده کنید',
      },
      useChrome: {
        text1:
          'مرورگری که از آن استفاده می‌کنید پشتیبانی نمی‌شود. برای جلوگیری از مشکلات احتمالی، از مرورگر کروم',
        text2: 'استفاده کنید',
      },
    },
    outdatedBrowser: {
      title: 'مرورگر قدیمی',
      description:
        'نسخه مرورگر شما قدیمی است. برای جلوگیری از مشکلات احتمالی، آن را بروزرسانی نمایید.',
      yourVersion: 'نسخه مرورگر شما',
      minVersion: 'نسخه قابل اجرا', // TODO
    },
    outdatedOs: {
      oldAndroid: 'اندروید قدیمی',
      oldIos: 'آی او اس قدیمی', // TODO
      updateAndroid:
        'نسخه اندروید شما قدیمی است. برای جلوگیری از مشکلات احتمالی، آن را بروزرسانی یا از دستگاه دیگری استفاده نمایید.',
      updateIos:
        'نسخه آی او اس شما قدیمی است. برای جلوگیری از مشکلات احتمالی، آن را بروزرسانی یا از دستگاه دیگری استفاده نمایید.',
    },
  },
  invite: {
    inviteViaPhone: 'دعوت از طریق شماره موبایل', // TODO
    checkboxOption: 'امکان دعوت دیگران را داشته باشد',
    inviteFromContacts: 'دعوت از لیست مخاطبین',
    yourInviter: 'دعوت کننده شما به پلتفرم',
    invited: 'دعوت شدگان',
    accepted: 'پذیرندگان دعوت',
    invitedAt: (date: number) =>
      `در تاریخ ${dateTimeFormatter.format(date)} دعوت شد`,
    invitationStatus: 'ظرفیت دعوت شما: ', // TODO
    sms: `سلام و عرض ادب، شما به پلتفرم ${APP_NAME} دعوت شده اید.
    ورود به پلتفرم: ${FRONT_HOST.replace(/(^\w+:|^)\/\//, '')}
    دانلود نسخه اندروید: ${TWA_DOWNLOAD_SRC.replace(/(^\w+:|^)\/\//, '')}`,
    oneUserSms: (
      phone: string,
    ) => `سلام و عرض ادب، شما به پلتفرم ${APP_NAME} دعوت شده اید.
     ${phone}شماره تلفن دعوت شده: 
    ورود به پلتفرم: ${FRONT_HOST.replace(/(^\w+:|^)\/\//, '')}
    دانلود نسخه اندروید: ${TWA_DOWNLOAD_SRC.replace(/(^\w+:|^)\/\//, '')}`,
    increaseCapacity: 'افزایش ظرفیت', // TODO
    inviteTeacher: `سلام و درود
می‌خواستم «پنل کاربری بنیاد شفیعی» رو بهتون معرفی کنم!✌️
اینجا میتونید کانال اختصاصی خودتون رو تاسیس کنید!😍
تو این کانال میتونید آزمون برگزار کنید، محتوای آموزشی بفرستید و از ابزارهای حرفه‌ای و #رایگان پنل کاربری بنیاد شفیعی استفاده کنید!👌

لینک نصب پنل کاربری بنیاد شفیعی👇

📱کافه بازار:
https://cafebazaar.ir/app/me.weblite.twa

📱مایکت:
https://myket.ir/app/me.weblite.twa`,
    inviteStudent: `سلام و درود
همین الان «پنل کاربری بنیاد شفیعی» رو نصب کن!🙌
اینجا کلی کانال درسی خوب پیدا میکنی!😍
تو این کانال‌ها میتونی تو آزمون شرکت کنی، به تک‌تست‌های چالشی جواب بدی و از درسنامه‌های نکته‌دار استفاده کنی!😎

تازه #همش_رایگانه 🎉

بیا از اینجا نصبش کن👇

📱کافه بازار:
https://cafebazaar.ir/app/me.weblite.twa

📱مایکت:
https://myket.ir/app/me.weblite.twa`,
  }, // add
  forward: {
    text: 'رسالة',
    wapp: 'برنامج',
    forward: (num: number, type: string) => `تحويل  ${toLocale(num)} ${type}`,
    forwardSameMessages: (num: number) => `تحويل  ${num} رسالة`,
    from: (name: string) => `از طرف ${name}`, // add
    fromTwo: (name1: string, name2: string) => `من جانب ${name1} و ${name2}`,
    fromSome: (name1: string, name2: string) => `باسم ${name1} و ${name2}و ...`,
    nMessages: (num: number) => `${toLocale(num)} پیام`, // add
    whatUDo: (num: number, src: string) =>
      `ماذا تريد أن تفعل ${toLocale(num)} رسالتين من جانب ${src}؟`,
    discardForward: 'الغاء',
  },
  shareContact: {
    choose: 'اختر جهة الاتصال الخاصة بك', // TODO: check with natives !
    share: 'مشاركة جهة الاتصال', // TODO: check with natives !
    viewContact: 'عرض جهة الاتصال', // TODO: check with natives !
  },
}
